import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen, ShieldCheck } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    icon: <Download className="w-10 h-10" data-id="element-96" />,
    title: 'Acceso Inmediato',
    desc: 'Al realizar su pago seguro, recibe la guía en su correo electrónico al instante. Sin esperas.'
  }, {
    num: '2',
    icon: <BookOpen className="w-10 h-10" data-id="element-97" />,
    title: 'Lectura Sencilla',
    desc: 'Un lenguaje claro, con letras grandes y ejemplos reales de nuestra comunidad hispana.'
  }, {
    num: '3',
    icon: <ShieldCheck className="w-10 h-10" data-id="element-98" />,
    title: 'Acción Segura',
    desc: 'Usted sigue la lista de pasos y solicita su beneficio con total confianza y preparación.'
  }];
  return <section className="py-20 bg-white" data-id="element-99">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-16" data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-4" data-id="element-102">
            Cómo funciona
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-103">
            Tres pasos simples para asegurar su futuro financiero hoy mismo.
          </p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={stagger} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-104">
          {steps.map((step, index) => <motion.div key={index} variants={fadeIn} className="relative flex flex-col items-center text-center p-8 rounded-2xl bg-[#FDF8F0] border border-[#E8D5A3]/50" data-id="element-105">
              <div className="absolute -top-6 bg-[#1B2A4A] text-[#C5A55A] w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold font-serif shadow-lg border-2 border-[#C5A55A]" data-id="element-106">
                {step.num}
              </div>
              <div className="text-[#C5A55A] mb-6 mt-4" data-id="element-107">{step.icon}</div>
              <h3 className="text-2xl font-bold text-[#1B2A4A] mb-4" data-id="element-108">
                {step.title}
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-109">{step.desc}</p>
            </motion.div>)}
        </motion.div>

        {/* Social Proof / Credibility */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="max-w-4xl mx-auto bg-gradient-to-br from-[#1B2A4A] to-[#0F1D33] rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-110">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#C5A55A]" data-id="element-111" />
          <p className="text-xl md:text-2xl text-white/90 font-serif italic leading-relaxed relative z-10" data-id="element-112">
            "Imagine despertarse cada mes sabiendo que su depósito bancario es
            un{' '}
            <strong className="text-[#C5A55A] text-3xl mx-1" data-id="element-113">
              30% más alto
            </strong>{' '}
            de lo que esperaba, simplemente porque aprendió a pedir los ajustes
            de cónyuge que otros ignoran. Esa es la tranquilidad que da el
            conocimiento."
          </p>
        </motion.div>
      </div>
    </section>;
}